import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { GridSizeRules } from '../../dashboard.types';

export const FINALIZE_POS_RULES: GridSizeRules = {
  minCols: 4, maxCols: 12,
  minRows: 4, maxRows: 16
};

@Component({
  selector: 'rny-finalize-pos-widget',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './finalize-purchase-orders.widget.html',
  styleUrls: ['./finalize-purchase-orders.widget.scss']
})

export class FinalizePurchaseOrdersWidget {


  /** KPI counts (bind from parent or load internally once wired to API) */
  @Input() pending = 0;
  @Input() ready = 0;
  @Input() blocked = 0;


  openList() {
    // TODO: route to your finalize-POs screen or open popup
    console.log('Open Finalize POs list');
  }
}
